export default {
  rs_001: {
    loc_ta_data: 5.7,
    loc_hd_data: 176,
    loc_hdd_ref_data: 2517,
    loc_zone_data: -1,
  },
  rs_002: {
    loc_ta_data: 5.6,
    loc_hd_data: 175,
    loc_hdd_ref_data: 2520,
    loc_zone_data: -1,
  },
  rs_003: {
    loc_ta_data: 4.8,
    loc_hd_data: 184,
    loc_hdd_ref_data: 2797,
    loc_zone_data: -1,
  },
  rs_004: {
    loc_ta_data: 4.5,
    loc_hd_data: 200,
    loc_hdd_ref_data: 3100,
    loc_zone_data: -1,
  },
  rs_005: {
    loc_ta_data: 5.5,
    loc_hd_data: 192,
    loc_hdd_ref_data: 2784,
    loc_zone_data: -1,
  },
  rs_006: {
    loc_ta_data: 4.3,
    loc_hd_data: 257,
    loc_hdd_ref_data: 4035,
    loc_zone_data: -1,
  },
  rs_007: {
    loc_ta_data: 5.3,
    loc_hd_data: 182,
    loc_hdd_ref_data: 2675,
    loc_zone_data: -1,
  },
  rs_008: {
    loc_ta_data: 5.7,
    loc_hd_data: 194,
    loc_hdd_ref_data: 2774,
    loc_zone_data: -1,
  },
  rs_009: {
    loc_ta_data: 5.8,
    loc_hd_data: 180,
    loc_hdd_ref_data: 2556,
    loc_zone_data: -1,
  },
  rs_010: {
    loc_ta_data: 5.2,
    loc_hd_data: 208,
    loc_hdd_ref_data: 3078,
    loc_zone_data: -1,
  },
  rs_011: {
    loc_ta_data: 4.2,
    loc_hd_data: 243,
    loc_hdd_ref_data: 3839,
    loc_zone_data: -1,
  },
  rs_012: {
    loc_ta_data: 5,
    loc_hd_data: 192,
    loc_hdd_ref_data: 2880,
    loc_zone_data: -1,
  },
  rs_013: {
    loc_ta_data: 4.4,
    loc_hd_data: 239,
    loc_hdd_ref_data: 3728,
    loc_zone_data: -1,
  },
  rs_014: {
    loc_ta_data: 4.9,
    loc_hd_data: 182,
    loc_hdd_ref_data: 2748,
    loc_zone_data: -1,
  },
  rs_015: {
    loc_ta_data: 4.9,
    loc_hd_data: 183,
    loc_hdd_ref_data: 2763,
    loc_zone_data: -1,
  },
  rs_016: {
    loc_ta_data: 2.8,
    loc_hd_data: 311,
    loc_hdd_ref_data: 5349,
    loc_zone_data: -1,
  },
  rs_017: {
    loc_ta_data: 5.5,
    loc_hd_data: 180,
    loc_hdd_ref_data: 2610,
    loc_zone_data: -1,
  },
  rs_018: {
    loc_ta_data: 5.4,
    loc_hd_data: 180,
    loc_hdd_ref_data: 2628,
    loc_zone_data: -1,
  },
  rs_019: {
    loc_ta_data: 5.5,
    loc_hd_data: 183,
    loc_hdd_ref_data: 2654,
    loc_zone_data: -1,
  },
  rs_020: {
    loc_ta_data: 5.4,
    loc_hd_data: 198,
    loc_hdd_ref_data: 2891,
    loc_zone_data: -1,
  },
  rs_021: {
    loc_ta_data: 5.5,
    loc_hd_data: 181,
    loc_hdd_ref_data: 2624,
    loc_zone_data: -1,
  },
  rs_022: {
    loc_ta_data: 5.4,
    loc_hd_data: 179,
    loc_hdd_ref_data: 2613,
    loc_zone_data: -1,
  },
  rs_023: {
    loc_ta_data: 4.7,
    loc_hd_data: 203,
    loc_hdd_ref_data: 3106,
    loc_zone_data: -1,
  },
  rs_024: {
    loc_ta_data: 5.2,
    loc_hd_data: 181,
    loc_hdd_ref_data: 2679,
    loc_zone_data: -1,
  },
  rs_025: {
    loc_ta_data: 5.1,
    loc_hd_data: 182,
    loc_hdd_ref_data: 2712,
    loc_zone_data: -1,
  },
  rs_026: {
    loc_ta_data: 5.7,
    loc_hd_data: 181,
    loc_hdd_ref_data: 2588,
    loc_zone_data: -1,
  },
  rs_027: {
    loc_ta_data: 5,
    loc_hd_data: 190,
    loc_hdd_ref_data: 2850,
    loc_zone_data: -1,
  },
  rs_028: {
    loc_ta_data: 4.9,
    loc_hd_data: 187,
    loc_hdd_ref_data: 2824,
    loc_zone_data: -1,
  },
  rs_029: {
    loc_ta_data: 3.5,
    loc_hd_data: 251,
    loc_hdd_ref_data: 4142,
    loc_zone_data: -1,
  },
  rs_030: {
    loc_ta_data: 5.2,
    loc_hd_data: 185,
    loc_hdd_ref_data: 2738,
    loc_zone_data: -1,
  },
  rs_031: {
    loc_ta_data: 5.4,
    loc_hd_data: 163,
    loc_hdd_ref_data: 2380,
    loc_zone_data: -1,
  },
  rs_032: {
    loc_ta_data: 5,
    loc_hd_data: 201,
    loc_hdd_ref_data: 3015,
    loc_zone_data: -1,
  },
  rs_033: {
    loc_ta_data: 5.5,
    loc_hd_data: 190,
    loc_hdd_ref_data: 2755,
    loc_zone_data: -1,
  },
  rs_034: {
    loc_ta_data: 5.7,
    loc_hd_data: 181,
    loc_hdd_ref_data: 2588,
    loc_zone_data: -1,
  },
  rs_035: {
    loc_ta_data: 5.4,
    loc_hd_data: 184,
    loc_hdd_ref_data: 2686,
    loc_zone_data: -1,
  },
  rs_036: {
    loc_ta_data: 5.4,
    loc_hd_data: 198,
    loc_hdd_ref_data: 2891,
    loc_zone_data: -1,
  },
  rs_037: {
    loc_ta_data: 5.3,
    loc_hd_data: 182,
    loc_hdd_ref_data: 2675,
    loc_zone_data: -1,
  },
  rs_038: {
    loc_ta_data: 5,
    loc_hd_data: 190,
    loc_hdd_ref_data: 2850,
    loc_zone_data: -1,
  },
  rs_039: {
    loc_ta_data: 5.7,
    loc_hd_data: 181,
    loc_hdd_ref_data: 2588,
    loc_zone_data: -1,
  },
  rs_040: {
    loc_ta_data: 5.4,
    loc_hd_data: 179,
    loc_hdd_ref_data: 2613,
    loc_zone_data: -1,
  },
  rs_041: {
    loc_ta_data: 5.4,
    loc_hd_data: 163,
    loc_hdd_ref_data: 2380,
    loc_zone_data: -1,
  },
  rs_042: {
    loc_ta_data: 5.4,
    loc_hd_data: 198,
    loc_hdd_ref_data: 2891,
    loc_zone_data: -1,
  },
};
